import type { FaireProductEntity } from "../../entity_types/product";

export const p_n79cdq8nh4: FaireProductEntity = {
  token: "p_n79cdq8nh4",
  type: "product",
  name: "Classic 3-Prong Moissanite Tennis Necklace - Gold Plated Sterling Silver",
  brandToken: "b_eow5j1bbc8",
  brandName: "Ellison+Young",
  imageUrl:
    "https://cdn.faire.com/fastly/75cad40cbb77ad366dcf1fbf5c7ee8be9fc01b20215aafdb7222c158b218ba7b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4c5f79f86b6e237652e132d1c9642cf085f2be0ec8066badca25f03848f5f3ce.jpeg",
    "https://cdn.faire.com/fastly/c3cdb711f281ff2bcb00a0c0642b4ad6c5ac32af281f8d9fb53dba74e136c937.jpeg",
    "https://cdn.faire.com/fastly/e18f44a191d44d94b72b929847fd786b606e5db379c2232c756e0f3121f149e4.jpeg",
    "https://cdn.faire.com/fastly/7417cab2609818160b935091e2fabb6305c190a00e601a6e300f31ffb867371a.jpeg",
    "https://cdn.faire.com/fastly/2a70c05d623bd05638162836b6184a0d549a1bb6db881e635f3edbe62a1aa87d.jpeg",
  ],
  priceDollars: 506.06,
  description:
    'Indulge in luxury with our Classic 3-Prong Moissanite Tennis Necklace. Crafted in gold dipped sterling silver, the slim design features evenly sized colorless moissanite stones set in a 3 prong setting for a stunning sparkle. The seamless box clasp with double latches adds a touch of elegance to this chic and stylish necklace. Upgrade your collection with this tasteful piece.\n\nMoissanite is set in sterling silver dipped in white gold\n\n*Chain Length: 17"\n*Box clasp closure with a safety latch\n\nConflict-free, socially responsible moissanite.\n\n*Color: DEF\n*Clarity: VVS\n*Moissanite size: 2 mm\n',
  tags: [],
  msrpDollars: 1265.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:59:26.402Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
